import _ from "lodash";

import { useArchiveContext } from "../../context/archive.context";
import { Select } from "./Select";
import { CategoryBubble } from "./CategoryBubble";
import { TagBubble } from "./TagBubble";

export const Categories = () => {
	const {lang, toggleLayout, categories, tags, selectQueryParams } =
		useArchiveContext();

	return (
		<div className="wrapHomeAgeGroup-38">
			<div
				className="
                MuiGrid-root
                main-container
                root-39
                rootSlide-37
                MuiGrid-container
            "
			>
				<div
					className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
					id="mtBubbles"
				>
					<div className="swipeRootWrap-73 swipeRootWrap-74" dir="rtl"></div>
				</div>
			</div>
			<div className="MuiGrid-root root-39 MuiGrid-container">
				<div
					className="MuiGrid-root mtSearch-50 MuiGrid-container"
					id="mtSearch"
				>
					<div
						className="
                        MuiGrid-root
                        topics-47
                        MuiGrid-item MuiGrid-grid-xs-12
                    "
					>
						<Select />

						{categories && categories.length ? (
							<CategoryBubble
								data={categories}
								handleSelect={(categoryId) => {
									selectQueryParams({ category: categoryId });
								}}
							/>
						) : (
							""
						)}

						<div className="topicRightWrap-55 topicRightWrap">
							<div className="topicsText-58">
								{lang.toLowerCase() === "ar" ? "المجالات" : "Topics"}
							</div>
							<div className="searchButton-49" onClick={toggleLayout}>
								{/* <img src={SearchIcon} alt="Search" /> */}
								<svg
									width="28"
									height="28"
									viewBox="0 0 28 28"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="search-icon"
								>
									<path
										d="M20.2489 11.4382C20.2489 16.5008 16.1448 20.6048 11.0822 20.6048C6.01958 20.6048 1.91553 16.5008 1.91553 11.4382C1.91553 6.37554 6.01958 2.27148 11.0822 2.27148C16.1448 2.27148 20.2489 6.37554 20.2489 11.4382Z"
										stroke="white"
										stroke-width="3"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
									<path
										d="M26 26L18 18"
										stroke="white"
										stroke-width="3"
										stroke-linejoin="round"
									/>
								</svg>
								<svg
									width="58"
									height="57"
									viewBox="0 0 58 57"
									fill="red"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M8.76711 3.95442C13.1748 0.00627004 24.8522 -0.0540889 30.3688 0.0123979C35.8852 0.0791912 45.1025 2.79565 48.7384 7.78646C52.316 12.6964 57.2237 21.0314 57.6807 27.5125C58.0151 32.2588 58.5457 38.7773 56.4932 42.9408C54.3007 47.3884 48.4395 52.8587 44.9725 55.1349C38.1522 59.6122 16.4116 55.2832 9.96313 50.0032C-2.54028 39.7651 -3.64987 15.0773 8.76711 3.95442Z"
										fill="#201F57"
									/>
								</svg>
							</div>
						</div>
					</div>

					{tags && tags.length ? <TagBubble data={tags} /> : ""}
				</div>
			</div>
		</div>
	);
};
